import { Task } from "@freeconvert/freeconvert-node/dist/types";

export const getFileExtFromTask = (task: Task) =>
    task.result?.url?.toString() ? task.result.url.toString().split("/").at(-1)?.split(".").at(-1) || "" : "";
